// extracted by mini-css-extract-plugin
module.exports = {"imageSquare":"Image_imageSquare__3COui","imageCircle":"Image_imageCircle__JpT3j"};